import { ArrowLeft } from 'lucide-react';
import React, { useEffect } from 'react';
import { Link, useInRouterContext, useLocation } from 'react-router-dom';
import { backPathFromSearch } from '../../../utils/backToChat';
import { capabilityForPath, trackConnect } from '../../../utils/connectTracking';
import './PageHeader.css';

/**
 * "← Back to chat" (CEL-3662 X1): the ONE back link of every page a connect card or a composer chip
 * opens (/cowork, /cowork/browse, /connectors/tools[/slug], /connectors/keys, /connectors/mcps,
 * /connectors/logins, /connectors/triggers/...). Rendered by the shared page headers (PageHeader,
 * ConnectorHeader) and the two Cowork pages' heroes. It shows ONLY when the page was opened with
 * `?back=<a same-origin path>` (utils/backToChat.js guards it); without one the page is exactly as
 * before. One click goes back to that chat inside the app (no reload).
 */
const BackToChatInner = ({ className = '' }) => {
  const location = useLocation();
  const back = backPathFromSearch(location.search);
  const capability = capabilityForPath(location.pathname);

  useEffect(() => {
    if (back && capability) trackConnect({ surface: 'page', capability, state: 'from_chat', action: 'shown' });
  }, [back, capability]);

  if (!back) return null;
  return (
    <Link
      to={back}
      className={`cc-page-back ${className}`.trim()}
      data-testid="back-to-chat"
      data-track="connect_page_back_to_chat"
      onClick={() => capability && trackConnect({ surface: 'page', capability, state: 'from_chat', action: 'back_to_chat' })}
    >
      <ArrowLeft size={14} aria-hidden="true" />
      Back to chat
    </Link>
  );
};

// Outside a router (a unit test rendering a header alone) there is no location to read: render nothing.
const BackToChatLink = (props) => (useInRouterContext() ? <BackToChatInner {...props} /> : null);

export default BackToChatLink;
